module.exports = __webpack_public_path__ + "img/caterpillar.5aee72ab.gif";